"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[5383],{

/***/ 5383:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ clickToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * @description
 * * Toggles the 'active' class on a given element on click
 * * Multiple triggers can toggle the active class on a single target
 *
 * @options HTML data properties on "wrapper" element
 * * [data-utility="click-toggle"] { required } - Wrapper element that runs this code
 * * [data-toggle] {required} - Pass query selector for target element
 * * [data-toggle-scroll] {optional} - Pass true to toggle scroll on the target element
 * * [data-handle-document-click] {optional} - Pass true to handle document click outside the wrapper
 */

function clickToggle({ wrapper }) {
  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle'),
    triggers: `[data-toggle="${jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle')}"]`,
    toggleScroll: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle-scroll'),
    handleDocumentClick: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('handle-document-click'),
  }

  const cache = {
    $targets: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers).not(wrapper).add(wrapper),
  }

  // TailwindCSS variants representing different states
  const { classes } = window.config

  ;(function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click.clickToggle.toggle', toggle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('toggle:close', close)
    if (selectors.handleDocumentClick === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', handleDocumentClick)
    }
  })()

  function handleDocumentClick(event) {
    const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target)

    // Only close if the click is outside the wrapper
    if (selectors.handleDocumentClick === true && !$target.closest(wrapper).length) {
      close()
    }
  }

  function toggle() {
    const isActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)

    cache.$targets.toggleClass(classes.active, !isActive)
    cache.$triggers.toggleClass(classes.active, !isActive)

    if (selectors.toggleScroll === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').toggleClass('no-scroll')
    }
  }

  function close() {
    cache.$targets.removeClass(classes.active)
    cache.$triggers.removeClass(classes.active)
  }
}


/***/ })

}]);